import { render, staticRenderFns } from "./TipDg.vue?vue&type=template&id=4331b702"
import script from "./TipDg.vue?vue&type=script&lang=js"
export * from "./TipDg.vue?vue&type=script&lang=js"
import style0 from "./TipDg.vue?vue&type=style&index=0&id=4331b702&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports